import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 13c2.255 0 7.5.39 7.5 4H2c0-3.61 5.245-4 7.5-4zm0-1C5.463 12 1 13.15 1 17v1h17v-1c0-3.85-4.463-5-8.5-5zm0-9C11.43 3 13 4.57 13 6.5S11.43 10 9.5 10 6 8.43 6 6.5 7.57 3 9.5 3zm0-1C7.015 2 5 4.015 5 6.5S7.015 11 9.5 11 14 8.985 14 6.5 11.985 2 9.5 2z',
  ],
  height: 20,
  width: 20,
});
